<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />">
</ngx-spinner>
<div dir="{{languageDir}}" class="user-action-wrapper">
  <section>
    <div class="content-top-box">
      <app-bread-crumb></app-bread-crumb>
    </div>
    <form [formGroup]="filterForm">
      <div class="content-row-wrap formInput">
        <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="width:16%">
          <mat-label>{{ (langObj?.DateRange | translate) || 'DateRange' }}</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate formControlName="startDate"
              placeholder="{{langObj ? langObj?.FromDate : ('FromDate' | translate)}}" />
            <input matEndDate formControlName="endDate"
              placeholder="{{langObj ? langObj?.ToDate : ('ToDate' | translate)}}" (dateChange)="onTDateChange()" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>

        <div class="inputField " style="width:16%">
          <label class="select-floating-label" for="multiselect">{{ (langObj?.Module | translate) || 'Module' }}</label>
          <p-multiSelect inputId="multiselect" formControlName="module" [options]="newModules" optionLabel="Name"
            [filter]="true" (onChange)="onInputChange($event)" maxSelectedLabels="{{ newModules.length - 1 }}"
            selectedItemsLabel="ALL">
          </p-multiSelect>
        </div>

        <div class="inputField" style="width:16%">
          <label class="select-floating-label" for="multiselect">{{ (langObj?.Department | translate) || 'Department' }}</label>
          <p-multiSelect inputId="multiselect" formControlName="department" [options]="Departments"
            optionLabel="TypeName" [filter]="true" (onChange)="onInputChange($event)" selectedItemsLabel="ALL"
            maxSelectedLabels="{{ Departments.length - 1 }}">
          </p-multiSelect>
        </div>

        <div class="inputField" style="width:16%">
          <label class="select-floating-label" for="multiselect">{{ (langObj?.Employee | translate) || 'Employee' }}</label>
          <p-multiSelect inputId="multiselect" formControlName="employee" [options]="employees" optionLabel="fullName"
            [filter]="true" (onChange)="onInputChange($event)" selectedItemsLabel="ALL"
            maxSelectedLabels="{{ employees.length - 1 }}">
          </p-multiSelect>
        </div>

        <div class="inputField" style="width:16%">
          <label class="select-floating-label" for="multiselect">{{ (langObj?.Status | translate) || 'Status' }} </label>
          <p-multiSelect inputId="multiselect" formControlName="status" [options]="status" optionLabel="name"
            selectedItemsLabel="ALL" maxSelectedLabels="{{ status.length - 1 }}" [(ngModel)]="selectedStatus"
            (onChange)="onInputChange($event)">
          </p-multiSelect>
        </div>
      </div>
    </form>

    <div class="p-grid p-fluid">
      <div class="p-lg-12 p-md-12 p-sm-12">
        <div class="card-row">
          <div class="card-wrapper">
            <div class="card-header">
              <span class="card-text">{{ (langObj?.TotalActions | translate) || 'TotalActions' }}</span>
              <span class="card-value">{{ totalActionsCount }}</span>
            </div>
            <div class="card-footer">
              <div id="Chart1"></div>
            </div>
          </div>

          <div class="card-wrapper">
            <div class="card-header">
              <span class="card-text">{{ (langObj?.CompletedActions | translate) || 'CompletedActions' }} </span>
              <span class="card-value">{{ completedActionsCount }}</span>
            </div>
            <div class="card-footer">
              <div id="Chart2"></div>
            </div>
          </div>

          <div class="card-wrapper">
            <div class="card-header">
              <span class="card-text">{{ (langObj?.PendingActions | translate) || 'PendingActions' }} </span>
              <span class="card-value">{{ pendingActionsCount }}</span>
            </div>
            <div class="card-footer">
              <div id="Chart3"></div>
            </div>
          </div>
        </div>
        <div class="addActionbtn" style="margin-top: 25px; margin-bottom:25px;">
          <button type="button" mat-flat-button *ngIf="isWrite | permissionChecker" color="accent" class="back-button" style="margin-left: 14px"
            (click)="openAddActionModal()">
            <p class="btn-text">{{ (langObj?.AddAction | translate) || 'AddAction' }}</p>
          </button>
        </div>
        <ag-grid-angular id="mainGrid" style="width: 100%; height: 30vw; margin-top: 15px" class="ag-theme-alpine"
          [columnDefs]="actionscolumnDefs" [rowData]="actionsrowData" [pagination]="true"
          [defaultColDef]="defaultColDef" (columnMoved)="saveState()" [paginationPageSize]="10"
          [loadingOverlayComponent]="loadingOverlayComponent"
          (gridReady)="onGridReady($event)" [gridOptions]="gridOptions" [sideBar]="sideBar"
          (cellClicked)="cellClicked($event)" [groupHideOpenParents]="true"
          (firstDataRendered)="onFirstDataRendered($event)" (filterChanged)="onFilterChanged($event)"
          (columnRowGroupChanged)="onColumnPivotChanged($event)">
        </ag-grid-angular>
      </div>
    </div>
  </section>

  <!-- [header]="fileDesc" -->
  <p-dialog  [header]="'Previewer'" [(visible)]="displayMaximizable" [modal]="true" [style]="{ width: '90vw',height: '95vh' }"
    [maximizable]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false" (onHide)="uponHide()">
    <ng-template pTemplate="header">
      <span *ngIf="fileType === 'doc'" class="text-xl font-bold previewer-download-icon"><a download [href]="doc"><i style="font-size:20px;position:relative;top:3px;" class="fa fa-download"></i></a></span>
    </ng-template>
    <ngx-doc-viewer *ngIf="fileType === 'doc'" [url]="doc" viewer="google" style="width: 100%; height: 90vh">
    </ngx-doc-viewer>
    <angular-image-viewer *ngIf="fileType === 'img'" [src]="images" [(index)]="imageIndexOne"></angular-image-viewer>
  </p-dialog>
</div>